import Address from "@/api/Address";

export class CustomerDTO {
    public id?: number;
    public firstname = "";
    public lastname = "";
    public email = "";
    public mobile = "";
    public nationalCode = "";
    public isSubscribed = false;
    public defaultAddress?: Address;
    public hasCustomImage = false;
    public customerImage = "";
    public imageVerified = false;
}

export default class Customer extends CustomerDTO{
    constructor(dto?: CustomerDTO) {
        super();
        if(dto) {
            Object.assign(this, dto);
        }
    }

    public getFullName(): string {
        return `${this.firstname} ${this.lastname}`;
    }
}